// @ts-nocheck
interface iPixelPayloadParams {
  name: string,
  contentType?: string,
  separator?: string,
  properties: any,
  context: any,
}

interface iCurrencyNumber {fieldId: string, fieldValue: string, fieldType: string}

export const keysPixel = {
  cp: '328658652481268'
}

export const pixelForbiddenKeywords = [
  "name",
  "email",
  "cpf",
  "phone",
  "bank_data",
  "account_data",
  "id_data",
  "date_of_birth",
]

const getCurrencyNumber = ({fieldId, fieldValue, fieldType} : iCurrencyNumber) => {
  const isCurrencyValue = fieldType === 'Currency' || fieldType === 'br-currency'

  if(!isCurrencyValue) {
    return {}
  }

  const valueDecimalsWithPoint = fieldValue.replace(/\./g, '').replace(',', '.')
  const valueNumbersAndDecimals = valueDecimalsWithPoint.replace(/[^\d.]/g, "")
  const valueFloat = parseFloat(valueNumbersAndDecimals)

  return { [`${fieldId}_number`]: valueFloat }
}

const generateFlatPayload : (payload: any | null, separator?: string, sub?: string) => void = (payload: any | null, separator = ".", sub?: string) => {
  return payload === null
    ? payload
    : Object.keys(payload).reduce((flatPayload, key) => {
        const value = payload[key]
        const subKey = sub ? `${sub}${separator}${key}` : key

        if (typeof value === 'object') {
          const subPayload: any = generateFlatPayload(value, separator, subKey)
          return { ...subPayload, ...flatPayload }
        } else {
          return {
            ...flatPayload,
            [subKey]: value,
          }
        }
      }, {})
}

const setFieldsObject = (propertiesFields: any) =>
  propertiesFields?.reduce((newFields: any, field: any) => {
    const { fieldId, fieldValue, fieldType } = field

    const hasForbiddenKeyword = !!pixelForbiddenKeywords.find((keyword) =>
      fieldId.toUpperCase().includes(keyword.toUpperCase())
    )

    const currencyNumber = getCurrencyNumber({fieldId, fieldValue, fieldType})

    return hasForbiddenKeyword
      ? newFields
      : { ...newFields, [fieldId]: fieldValue, ...currencyNumber }
  }, {})


export const generatePixelPayload = ({ name, properties = {}, contentType = "product", context = {}, separator } : iPixelPayloadParams) => {
  const fbEventName : { [ key: string] : string } = {
    formViewed: 'ViewContent',
    formSubmitted: 'AddToCart',
  }

  const isSpecialEvent = Object.keys(fbEventName).includes(name)

  const getSpecialEventProp = (prop: any) => {
    return isSpecialEvent ? prop : null
  }

  const contentIds = properties?.captureContext?.valueProp
  const content_type = getSpecialEventProp(contentType)
  const content_ids = getSpecialEventProp(contentIds)

  const fields = setFieldsObject(properties?.field)

  const newProperties = {
    ...properties,
    field: fields,
  }

  const flatPayload: any = generateFlatPayload({
    properties: newProperties,
    context,
  },
  separator
  )

  return { ...flatPayload, content_type, content_ids }
}

export const pixel = (name: string, properties = {}, contentType?: string, context = {}) => {
  const fbEventName : { [ key: string ] : string} = {
    formViewed: 'ViewContent',
    formSubmitted: 'AddToCart',
  }

  const isSpecialEvent = Object.keys(fbEventName).includes(name)

  const eventPayload = generatePixelPayload({ name, properties, contentType, context })

  if (typeof fbq !== 'undefined') {
    if (isSpecialEvent) {
      //eslint-disable-next-line
      fbq('trackSingleCustom', keysPixel.cp, fbEventName[name], eventPayload)
    }
    //eslint-disable-next-line
    fbq('trackSingleCustom', keysPixel.cp, name, eventPayload)
  }
}
